/**
 * Errors a game can branch on.
 *
 * The rule here is that every failure a game is expected to *handle* gets a
 * stable `code`, and every code carries a `retryable` verdict the SDK has
 * already worked out. A game author should never have to parse an HTTP status
 * or a message string to decide whether to try again — that decision depends on
 * platform semantics the game does not have, such as the fact that a rejected
 * score is rejected permanently while a 503 is not.
 */
export class TRYPORTALError extends Error {
    code;
    retryable;
    /** Present when the failure came back from the platform over HTTP. */
    status;
    detail;
    constructor(code, message, options = {}) {
        super(message, options.cause === undefined ? undefined : { cause: options.cause });
        this.name = 'TRYPORTALError';
        this.code = code;
        this.retryable = options.retryable ?? false;
        this.status = options.status;
        this.detail = options.detail;
    }
}
/** Narrow an unknown catch binding without instanceof across realms. */
export function isTRYPORTALError(error) {
    return (typeof error === 'object' &&
        error !== null &&
        error.name === 'TRYPORTALError' &&
        typeof error.code === 'string');
}
/**
 * Whether an HTTP status means "the platform did not get this".
 *
 * 408, 429 and 5xx are transport-shaped: the submission may never have been
 * evaluated, so replaying it under the same Idempotency-Key is both safe and
 * useful. Every other 4xx is a verdict, and repeating it only wastes the
 * session's submission budget.
 */
export function isRetryableStatus(status) {
    return status === 408 || status === 429 || status >= 500;
}
